// src/services/instances/season-team.ts

import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';

import {
  GetSeasonTeamsResponse,
  PostSeasonTeamResponse,
  PostSeasonTeamsBatchResponse,
} from '../response/season-team';

import {
  PostSeasonTeamRequest,
  PostSeasonTeamsBatchRequest,
} from '../request/season-team';

export class SeasonTeamService {
  /** GET /season-teams — paginado. Filtros via QueryParams (`season_uuid`, etc). */
  static getSeasonTeams(params?: QueryParams) {
    return apiClient.get<GetSeasonTeamsResponse>(buildApiUrl('/api/v1/competitions/season-teams'), params);
  }

  /** POST /season-teams — associa um time. */
  static postSeasonTeam(data: PostSeasonTeamRequest) {
    return apiClient.post<PostSeasonTeamResponse>(buildApiUrl('/api/v1/competitions/season-teams'), data);
  }

  /** POST /season-teams/batch — associa vários. */
  static postSeasonTeamsBatch(data: PostSeasonTeamsBatchRequest) {
    return apiClient.post<PostSeasonTeamsBatchResponse>(
      buildApiUrl('/api/v1/competitions/season-teams/batch'),
      data,
    );
  }

  /** DELETE /season-teams/:id — remove pelo uuid do SeasonTeam. */
  static deleteSeasonTeam(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/season-teams/:id', { id }), undefined);
  }
}
